import { Directive, HostListener, ElementRef } from '@angular/core';
import { CodeFormatPipe } from "../_pipes/code-format.pipe";
import { ValidationDocumentComponent } from "../pages/validation-document/validation-document.component";

@Directive({
  selector: '[appCodeMask]',
  standalone: true
})
export class CodeMaskDirective {

  constructor(private el: ElementRef, private validationComponent: ValidationDocumentComponent) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const inputValue: string = this.el.nativeElement.value;
    let unformattedValue = CodeFormatPipe.format(inputValue);

    if (!inputValue) {
      this.validationComponent.validationData = null;
      this.validationComponent.errorMessage = '';
    }

    if (unformattedValue.length > 16) {
      unformattedValue = unformattedValue.substring(0, 16);
    }

    const formattedValue = new CodeFormatPipe().transform(unformattedValue);

    if (formattedValue !== inputValue) {
      this.el.nativeElement.value = formattedValue;
    }
  }
}
